import L from 'leaflet';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

export const LabelLayer = () => {
    const map = useMap();
    
    useEffect(() => {
        var topPane = map.createPane('leaflet-top-pane', map.getPanes().mapPane);
        topPane.style.zIndex = '2005';
        var topLayer = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_only_labels/{z}/{x}/{y}{r}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions" target="_blank">CARTO</a>',
            subdomains: 'abcd',
            maxZoom: 18,
            className: 'voyager-label-tile',
            pane: 'leaflet-top-pane',
            zIndex: 2
        }).addTo(map);
        // @ts-ignore
        topPane.appendChild(topLayer.getContainer());
        topLayer.setZIndex(2005);
    }, []);

    useEffect(() => {
        if (map) {

            if (!map.getPane('overlayMarkersPane')) {
                map.createPane('overlayMarkersPane');
                map.getPane('overlayMarkersPane')!.style.zIndex = '2002';
            }
            if (!map.getPane('alertMarkersPane')) {
                map.createPane('alertMarkersPane');
                map.getPane('alertMarkersPane')!.style.zIndex = '2001';
            }
            if (!map.getPane('highPriorityMarkersPane')) {
                map.createPane('highPriorityMarkersPane');
                map.getPane('highPriorityMarkersPane')!.style.zIndex = '2000';
            }
            if (!map.getPane('priorityMarkersPane')) {
                map.createPane('priorityMarkersPane');
                map.getPane('priorityMarkersPane')!.style.zIndex = '1999';
            }
            if (!map.getPane('nonPriorityMarkersPane')) {
                map.createPane('nonPriorityMarkersPane');
                map.getPane('nonPriorityMarkersPane')!.style.zIndex = '1998';
            }
            if (!map.getPane('normalMarkersPane')) {
                map.createPane('normalMarkersPane');
                map.getPane('normalMarkersPane')!.style.zIndex = '1995';
            }
			if(map.getPane('markerPane')){
				map.getPane('markerPane')!.style.zIndex = '2005';
			}
        }
    }, [map]);
    
    return <></>
}
